export const getKey = (entityId: number, entityType: string) => {
  return `${entityId}_${entityType}`;
};
